export default {
  methods: {
    roundNumber(val, pos = 2) {
      return Math.round(val * Math.pow(10, pos)) / Math.pow(10, pos)
    },
    calculateVat(cart) {
      let result = {
        include: 0,
        exclude: 0,
        total: 0
      }
      if (cart) {
        try {
          result = cart.reduce(
            (prev, curr) => {
              if (curr.vat_types && curr.vat_value) {
                switch (curr.vat_types) {
                  case 'include':
                    prev.include += (curr.discountprice * curr.vat_value) / 100
                    prev.total += (curr.discountprice * curr.vat_value) / 100

                    break
                  case 'exclude':
                    prev.exclude += (curr.discountprice * curr.vat_value) / 100
                    prev.total += (curr.discountprice * curr.vat_value) / 100
                    break
                }
              }
              return prev
            },
            {
              include: 0,
              exclude: 0,
              total: 0
            }
          )

          return {
            exclude: Math.round(result.exclude),
            include: Math.round(result.include),
            total: Math.round(result.total)
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
      return result
    },
    getplaceInfo(placesinfo, distance, ableToBuy, shippingPrice) {
      return (
        placesinfo +
        ` (${distance} Km)` +
        `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: ${
          ableToBuy ? 'green' : 'red'
        }">${
          ableToBuy ? ` ค่าส่ง ${shippingPrice} บาท` : ' ไม่สามารถจัดส่งได้'
        }</div>`
      )
    },
    formatProducts(products, categories) {
      var product_by_index = {}
      products.forEach((val, index) => {
        products[index].price = parseFloat(products[index].price)
        products[index].discountprice = parseFloat(
          products[index].discountprice
        )
        products[index].isOutOfStock = false

        if (categories) {
          var categoryIndex = categories.findIndex(
            (x) => x.id === products[index].categoryid
          )

          if (categoryIndex != -1) {
            categories[categoryIndex].productCount++
          }
        }
        if (
          products[index].productstock &&
          products[index].productstock.length > 0
        ) {
          var haveStock = false
          val.productstock.forEach(function (pval, pindex) {
            if (parseInt(products[index].productstock[pindex][2]) > 0) {
              haveStock = true
            }

            var price = 0
            var discount = 0

            if (pval[3] == null && pval[4] == null) {
              price = parseFloat(val.price)
              discount = parseFloat(val.discountprice)
            } else {
              if (pval[3] == null) {
                price = parseFloat(val.price)
              } else {
                price = parseFloat(products[index].productstock[pindex][3])
              }

              if (pval[4] == null) {
                discount = products[index].productstock[pindex][3]
              } else {
                discount = parseFloat(products[index].productstock[pindex][4])
              }
            }

            products[index].productstock[pindex][3] = price

            products[index].productstock[pindex][4] = discount
            if (products[index].productstock[pindex][7] == 'null')
              products[index].productstock[pindex][7] = null
          })

          if (!haveStock) {
            products[index].isOutOfStock = true
          }
        } else {
          products[index].isOutOfStock = true
        }
        if (val) {
          product_by_index[val.id] = val
        }
      })

      return {
        products: products,
        product_by_index: product_by_index
      }
    },
    calculateBundlePrice: function (price, quantity, productbundle) {
      let bundle = productbundle.find(
        (bundle) =>
          bundle.maxquantity >= quantity && quantity >= bundle.minquantity
      )
      if (bundle) {
        return parseFloat(bundle.price)
      } else {
        return parseFloat(price)
      }
    },
    checkProductStock: function (stock, product) {
      if (stock.length == 0) {
        return null
      }

      let option = null
      try {
        option = stock.find((val) => val[1] == product.option)
      } catch (error) {
        //
      }

      return option
    },
    async goToErrorInput() {
      var vm = this
      if (vm.$validator.errors.items) {
        vm.$validator.errors.items.forEach(async (error) => {
          if (vm.$el.querySelector('[data-vv-name="' + error.field + '"]')) {
            await vm.$nextTick()
            vm.$el
              .querySelector('[data-vv-name="' + error.field + '"]')
              .scrollIntoView()
            return false
          } else if (vm.$el.querySelector('[name="' + error.field + '"]')) {
            await vm.$nextTick()
            vm.$el
              .querySelector('[name="' + error.field + '"]')
              .scrollIntoView()
            return false
          }
        })
      }
    },
    getStyle(selector, type) {
      let box = document.querySelector(selector)
      let style = getComputedStyle(box)
      // width and height without border and margin
      let width = box.clientWidth
      let height = box.clientHeight

      let marginLeft = parseInt(style.marginLeft)
      let marginRight = parseInt(style.marginRight)
      let marginTop = parseInt(style.marginTop)
      let marginBottom = parseInt(style.marginBottom)

      let borderTopWidth = parseInt(style.borderTopWidth) || 0
      let borderLeftWidth = parseInt(style.borderLeftWidth) || 0
      let borderBottomWidth = parseInt(style.borderBottomWidth) || 0
      let borderRightWidth = parseInt(style.borderRightWidth) || 0

      let paddingLeft = parseInt(style.paddingLeft) || 0
      let paddingRight = parseInt(style.paddingRight) || 0
      let paddingTop = parseInt(style.paddingTop) || 0
      let paddingBottom = parseInt(style.paddingBottom) || 0

      switch (type) {
        case 'width':
          return (
            width +
            borderLeftWidth +
            borderRightWidth +
            marginLeft +
            marginRight
          )
        case 'height':
          return (
            height +
            borderTopWidth +
            borderBottomWidth +
            marginTop +
            marginBottom
          )
        case 'offsetWidth':
          return width + borderLeftWidth + borderRightWidth
        case 'offsetHeight':
          return height + borderTopWidth + borderBottomWidth
        case 'clientWidth':
          return width
        case 'clientHeight':
          return height
        case 'contentWidth':
          return width - paddingLeft - paddingRight
        case 'contentHeight':
          return height - paddingTop - paddingBottom
        default:
          return undefined
      }
    },
    addClass(selector, className) {
      let obj = document.getSelection(selector)
      if (obj && obj.classList && !obj.classList.contains(className))
        obj.classList.add(className)
    },
    removeClass(selector, className) {
      let obj = document.getSelection(selector)
      if (obj && obj.classList && obj.classList.contains(className))
        obj.classList.remove(className)
    },
    getCurrencyByCode(code) {
      if (code) {
        switch (code.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'LAK':
            return '₭'
          case 'KRW':
            return '₩'
          case 'GBP':
            return '£'
          case 'BDT':
            return '৳'
          default:
            return '$'
        }
      }
      return '฿'
    },
    getMatchBundleGroup(bundles, cart) {
      let result = bundles
        .map((bundle) => {
          const filterCart = cart.filter((product) => {
            return bundle.products.some(
              (bundleProduct) => bundleProduct.id == product.id
            )
          })
          const totalQuantity = filterCart.reduce((prev, curr) => {
            prev += curr.quantity
            return prev
          }, 0)
          const minBundle = Math.floor(
            totalQuantity / bundle.quantity_condition
          )
          if (totalQuantity > 0 && minBundle > 0) {
            cart = cart.filter((product) => {
              const isFound = bundle.products.some(
                (bundleProduct) => bundleProduct.id == product.id
              )
              return !isFound
            })

            return { ...bundle, filterCart }
          } else {
            return { ...bundle, filterCart: [] }
          }
        })
        .filter((bundle) => bundle.filterCart && bundle.filterCart.length)
      result = result || []
      result.push({
        id: 'other',
        filterCart: cart
      })

      return result
    },
    getAppTypeFromUser(userid) {
      let app = ''
      if (userid) {
        let split_userid = userid.split('__')
        if (split_userid.length === 2) {
          if (userid.startsWith('U') || userid.startsWith('LU')) {
            app = 'line'
          } else {
            app = 'instagram'
          }
        } else {
          app = 'facebook'
        }
      } else {
        app = 'salepage'
      }
      return app
    }
  }
}
